(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zoid", [], factory);
	else if(typeof exports === 'object')
		exports["zoid"] = factory();
	else
		root["zoid"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 